import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, IconV1 } from 'design-library';
import { AppContext, AuthContext } from 'common/contexts';
import { ExpertHireIcon } from 'common/icons'; // TO DO replace with v2

import { NavProfileButton } from './NavProfileButton';
import { Button } from '@mui/material';

function Navbar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { currentUserRole } = useContext(AppContext);
  const { isAuthenticated, signinRedirect } = useContext(AuthContext);

  const routes = ['users', 'jobPosts', 'projects', 'settings'];

  return (
    <Box styles={{ background: '#063065', borderRadius: '0', paddingY: '8px' }}>
      <Box
        styles={{ paddingX: '12px' }}
        onClick={() => {
          if (!currentUserRole) {
            return navigate('/');
          }
          navigate('/');
        }}
      >
        <IconV1 className="nav-left-logo" icon={ExpertHireIcon} />
      </Box>
      <Box>
        {routes.map((route) => (
          <Button
            key={route}
            onClick={() => navigate(route)}
            sx={{
              color: 'white',
              fontWeight: pathname === `/${route}` ? 1000 : 200,
            }}
          >
            {route}
          </Button>
        ))}
      </Box>

      <Box
        styles={{
          alignItems: 'center',
          justifyContent: 'flex-end',
          paddingX: '12px',
        }}
      >
        {isAuthenticated() ? (
          <NavProfileButton />
        ) : (
          <Button onClick={signinRedirect}>Login</Button>
        )}
      </Box>
    </Box>
  );
}

export default Navbar;
